export type LocalizedTextMap = Record<string, string>;
export type LocalizedString = string | LocalizedTextMap;

export const getLocalizedString = (
  value: LocalizedString | null | undefined,
  lang: string,
  fallbackLang: string = 'en',
  defaultValue: string = ''
): string => {
  if (typeof value === 'string') return value;
  if (!value || typeof value !== 'object') return defaultValue;

  const v = value as LocalizedTextMap;
  const direct = v[lang];
  if (typeof direct === 'string' && direct.trim() !== '') return direct;

  const fb = v[fallbackLang];
  if (typeof fb === 'string' && fb.trim() !== '') return fb;

  const first = Object.values(v).find((x) => typeof x === 'string' && x.trim() !== '');
  return typeof first === 'string' ? first : defaultValue;
};

export const setLocalizedString = (
  value: LocalizedString | null | undefined,
  lang: string,
  nextText: string
): LocalizedTextMap => {
  const base: LocalizedTextMap = (value && typeof value === 'object') ? { ...(value as LocalizedTextMap) } : {};
  base[lang] = nextText;
  return base;
};
